export const sections = [
  {
    title: "MISIÓN",
    text: "Incorporar acciones que busquen brindar eficiencia y calidad en la prestación del servicio del agua con responsabilidad social, la creación de sistemas modernos a través de mejoras continuas en el aprovechamiento de recursos naturales, garantizando así la satisfacción de las demandas presentes y futuras del agua (vital líquido).",
  },
  {
    title: "VISIÓN",
    text: "Ser un modelo sustentable que permita al organismo, satisfacer las necesidades de la población de forma eficiente, que busque promover una cultura corresponsable sobre el cuidado del agua y garantizar el bienestar y calidad de vida de los ciudadanos.",
  },
];